import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { IMAGES, MARQUEE_WORDS, CONTACT } from "../../content.js";

const explore = [
  { label: "Home", to: "/" },
  { label: "Our Clubs", to: "/our-clubs" },
  { label: "Facilities", to: "/facilities" },
  { label: "Blue Membership", to: "/blue-membership" },
  { label: "Community", to: "/community" },
  { label: "Events & Experiences", to: "/events" },
  { label: "About / Our Story", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="grain relative overflow-hidden bg-navy text-white">
      <div className="relative z-10 mx-auto max-w-[1440px] px-6 pb-10 pt-20 lg:px-12 lg:pt-28">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="flex flex-col gap-6 lg:col-span-4">
            <img data-testid="footer-brand-logo" src={IMAGES.logoWhite} alt="Oneiros The Sports Club — Redefine Your Routine" className="h-[69px] w-auto object-contain" />
            <p className="max-w-sm text-sm leading-relaxed text-white/60">
              More than a gym — a complete sports, fitness, wellness, family and community ecosystem across Surat, Gujarat.
            </p>
            <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-brand">Redefine Your Routine</p>
          </div>

          <div className="lg:col-span-3">
            <h3 className="eyebrow mb-6">Explore</h3>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-3 lg:grid-cols-1">
              {explore.map((l) => (
                <li key={l.to}>
                  <Link data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} to={l.to} className="text-sm text-white/70 transition-colors hover:text-brand">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5">
            <h3 className="eyebrow mb-6">Visit Our Clubs</h3>
            <ul className="flex flex-col gap-6">
              {CONTACT.clubs.map((club) => (
                <li key={club.id} className="border-b border-white/10 pb-5 last:border-0" data-testid={`footer-club-${club.id}`}>
                  <p className="font-display text-xl">{club.name}</p>
                  <p className="mt-1 flex items-start gap-2 text-sm text-white/60">
                    <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand" />
                    {club.address ? (
                      <a href={club.mapUrl || "#"} target="_blank" rel="noopener noreferrer" className="hover:text-brand">
                        {club.address}
                      </a>
                    ) : (
                      <span className="italic">{club.addressNote || "Location details updating soon"}</span>
                    )}
                  </p>
                  {club.phone && (
                    <a data-testid={`footer-phone-${club.id}`} href={club.phoneHref} className="mt-1.5 flex items-center gap-2 text-sm text-white/70 transition-colors hover:text-brand">
                      <Phone className="h-3.5 w-3.5 text-brand" /> {club.phone}
                    </a>
                  )}
                </li>
              ))}
            </ul>
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="mt-2 flex items-center gap-2 text-sm text-white/70 transition-colors hover:text-brand">
              <Mail className="h-3.5 w-3.5 text-brand" /> {CONTACT.email}
            </a>
          </div>
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 md:flex-row">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} Oneiros Sports Club, Surat, Gujarat. All rights reserved.</p>
          <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-white/40">
            {MARQUEE_WORDS.join(" • ")}
          </p>
        </div>
      </div>
    </footer>
  );
}
